import RootModal, { RootModalProps } from "@/components/RootModal/RootModal";
import useTranslation from "@/hooks/useTranslation";
import { Form, Input, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useAddConsumable } from "../useConsumables";

export default function AddConsumable(props: RootModalProps) {
  const addConsumable = useAddConsumable();
  const navigate = useNavigate();
  const [form] = useForm<{ name: string }>();
  const t = useTranslation();

  const onSubmit = () => {
    form
      .validateFields()
      .then((x) => {
        addConsumable
          .mutateAsync({ name: x.name })
          .then(({ data: consumable }) => {
            message.success("Consumable has been created.");
            navigate("/consumables/" + consumable.id);
          })
          .catch(() => message.error(t.errors.general));
      })
      .catch(() => message.error("Enter a name to create a new consumable."));
  };

  return (
    <RootModal
      {...props}
      title="Add consumable"
      okButtonProps={{ onClick: onSubmit }}
      okText="Add"
    >
      <Form
        form={form}
        onKeyUp={(e) => {
          if (e.code === "Enter") onSubmit();
        }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="text" />
        </Form.Item>
      </Form>
    </RootModal>
  );
}
